import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { Link } from 'react-router-dom';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetSent, setResetSent] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }
    const { data: prof } = await supabase.from('profiles').select('approved').eq('id', data.user.id).single();
    if (!prof?.approved) {
      await supabase.auth.signOut();
      setError('Hesabınız henüz onaylanmadı. Onaylandığında giriş yapabileceksiniz.');
      setLoading(false);
    } else {
      sessionStorage.setItem('just_logged_in', '1');
      window.location.replace('/');
    }
  }

  async function handleReset(e) {
    e.preventDefault();
    setResetLoading(true);
    await supabase.auth.resetPasswordForEmail(resetEmail, {
      redirectTo: 'https://trial-track-xi.vercel.app/reset-password',
    });
    setResetSent(true);
    setResetLoading(false);
  }

  if (showReset) return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}><span style={styles.logoIcon}>🔑</span></div>
        <h2 style={styles.title}>Şifremi Unuttum</h2>
        {resetSent ? (
          <>
            <div style={styles.successBox}>
              📬 <strong>{resetEmail}</strong> adresine şifre sıfırlama bağlantısı gönderdik.
            </div>
            <p style={{ textAlign: 'center', fontSize: '0.82rem', color: '#94a3b8', marginBottom: '1.25rem' }}>
              E-posta gelmezse spam klasörünüzü kontrol edin.
            </p>
            <button style={styles.button} onClick={() => { setShowReset(false); setResetSent(false); setResetEmail(''); }}>
              Giriş Sayfasına Dön
            </button>
          </>
        ) : (
          <>
            <p style={{ color: '#475569', fontSize: '0.9rem', lineHeight: 1.6, marginBottom: '1.25rem', textAlign: 'center' }}>
              Kayıtlı e-posta adresinizi girin.
            </p>
            <form onSubmit={handleReset}>
              <input style={styles.input} type="email" placeholder="E-posta adresiniz" value={resetEmail} onChange={e => setResetEmail(e.target.value)} required />
              <button style={styles.button} type="submit" disabled={resetLoading}>
                {resetLoading ? 'Gönderiliyor...' : '📧 Sıfırlama Bağlantısı Gönder'}
              </button>
            </form>
            <p style={styles.link}>
              <button style={styles.linkBtn} onClick={() => setShowReset(false)}>← Giriş sayfasına dön</button>
            </p>
          </>
        )}
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}><span style={styles.logoIcon}>🔬</span></div>
        <h1 style={styles.title}>Klinik Araştırma Takip Portalı</h1>
        <form onSubmit={handleLogin}>
          <input style={styles.input} type="email" placeholder="E-posta" value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={styles.input} type="password" placeholder="Şifre" value={password} onChange={e => setPassword(e.target.value)} required />
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>
        <div style={styles.bottom}>
          <button style={styles.linkBtn} onClick={() => setShowReset(true)}>Şifremi unuttum</button>
          <span style={{ color: '#cbd5e1' }}>|</span>
          <Link to="/register" style={styles.linkA}>Kayıt Ol</Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f4f8' },
  card: { background: 'white', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' },
  logoWrap: { textAlign: 'center', marginBottom: '0.75rem' },
  logoIcon: { fontSize: '2.5rem' },
  title: { textAlign: 'center', color: '#1e3a5f', marginBottom: '1.5rem', fontSize: '1.2rem', fontWeight: '700', lineHeight: 1.3 },
  input: { width: '100%', padding: '0.75rem', marginBottom: '1rem', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '1rem', boxSizing: 'border-box' },
  button: { width: '100%', padding: '0.75rem', background: '#1e3a5f', color: 'white', border: 'none', borderRadius: '8px', fontSize: '1rem', cursor: 'pointer' },
  error: { color: '#ef4444', marginBottom: '1rem', fontSize: '0.875rem' },
  bottom: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.75rem', marginTop: '1.25rem', fontSize: '0.875rem' },
  link: { textAlign: 'center', marginTop: '1rem', fontSize: '0.875rem', color: '#64748b' },
  linkBtn: { background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', fontSize: '0.875rem', padding: 0 },
  linkA: { color: '#3b82f6', textDecoration: 'none', fontSize: '0.875rem' },
  successBox: { background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px', padding: '1rem', marginBottom: '1rem', fontSize: '0.9rem', color: '#166534', lineHeight: 1.7 },
};
